'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Prefix that is used to generate CSS class names, etc.
 *
 * @type {string}
 */
var prefix = exports.prefix = 'social-likes';

/**
 * Delimiter that is used to separate element.
 *
 * @type {string}
 */
var elemDelimiter = exports.elemDelimiter = '__';

/**
 * Delimiter that is used to separate modifier.
 *
 * @type {string}
 */
var modDelimiter = exports.modDelimiter = '_';


//////////////////
// WEBPACK FOOTER
// ./node_modules/social-likes-next/lib/config.js
// module id = 2
// module chunks = 0